// extracted by mini-css-extract-plugin
export default {"SlideDownContent":"SlideDownContent-module-a009c4fbabad4d368de5"};